import gql from 'graphql-tag'

export const exportDSFin = gql`
mutation initExportDSFin($params: exportDSFinInput!) {
	cashAssist {
		initExportDSFin(params: $params)
	}
}`

export const getDSFinExport = gql`
query getDSFinExport($requestId: ID!) {
	cashAssist {
		getDSFinExport(requestId: $requestId) {
			status
			progress
			error
			file {
				url
			}
		}
	}
}`
